import { BlockSettingsGroups } from './types';
import NavigationSettings from './NavigationSettings/NavigationSettings';
import BorderSettings from './BorderSettings/BorderSettings';

export const blockSettings: BlockSettingsGroups = {
  Button: { action: [NavigationSettings], style: [BorderSettings] },
};
